import { upperFirst } from 'lodash'

import { regExp } from '@sigma-frontend-libs/commons'

import { proxy } from '@/utils'

import settingsFields from '@/components/services/settings/fields'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy() ],

    methods: {
      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    },

    render(h) {
      return h(
        settingsFields(options),
        {
          props: {
            value: this.proxy,
            items: [
              {
                props: {
                  mask: regExp.positiveNumber,
                  defaultValue: '0'
                }
              }
            ]
          },
          on: {
            input: event => {
              this.$emit('input', event)
            }
          }
        }
      )
    }
  }
}
